import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { BUSINESS } from "../../data";

const fade = {
  hidden: { opacity: 0, y: 18 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: 0.1 + i * 0.1, ease: [0.22, 1, 0.36, 1] } }),
};

const HERO_IMG = "/brand/hero.webp";

export default function Hero({ onBook }) {
  return (
    <section className="bg-cream pt-28 pb-16 sm:pt-32">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 lg:grid-cols-2 lg:gap-16">
        <div>
          <motion.p custom={0} variants={fade} initial="hidden" animate="show"
            className="mb-5 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.25em] text-ink/45">
            <span className="h-px w-8 bg-ink/30" />
            Premium mobile car detailing
          </motion.p>

          <motion.h1 custom={1} variants={fade} initial="hidden" animate="show"
            className="font-display text-4xl leading-[1.05] text-ink sm:text-5xl lg:text-6xl">
            A cleaner car,<br />done properly.
          </motion.h1>

          <motion.p custom={2} variants={fade} initial="hidden" animate="show"
            className="mt-5 max-w-md text-base text-ink/60 sm:text-lg">
            Pine &amp; Shine brings showroom-quality detailing to your driveway.
            Honest pricing, careful work, pay in person. Book in under two minutes.
          </motion.p>

          <motion.div custom={3} variants={fade} initial="hidden" animate="show"
            className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button data-testid="hero-book-btn" onClick={onBook}
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-ink px-7 py-3.5 text-sm font-semibold uppercase tracking-widest text-cream transition-transform active:scale-95">
              Book Appointment
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </button>
            <a data-testid="hero-call-btn" href={BUSINESS.phoneHref}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-ink/20 px-7 py-3.5 text-sm font-semibold uppercase tracking-widest transition-colors hover:bg-ink hover:text-cream">
              <Phone size={15} /> {BUSINESS.phone}
            </a>
          </motion.div>

          <motion.div custom={4} variants={fade} initial="hidden" animate="show"
            className="mt-10 flex gap-8 border-t border-ink/10 pt-6">
            <div>
              <p className="font-display text-2xl">4+ hrs</p>
              <p className="text-xs uppercase tracking-widest text-ink/50">Per full detail</p>
            </div>
            <div>
              <p className="font-display text-2xl">We come</p>
              <p className="text-xs uppercase tracking-widest text-ink/50">To you</p>
            </div>
            <div>
              <p className="font-display text-2xl">5.0</p>
              <p className="text-xs uppercase tracking-widest text-ink/50">Customer rated</p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="relative">
          <div className="overflow-hidden rounded-3xl border border-ink/10">
            <img src={HERO_IMG} alt="BMW M covered in foam during a Pine & Shine wash" className="aspect-[4/5] w-full object-cover" />
          </div>
          <div className="absolute bottom-5 left-5 rounded-2xl bg-cream/95 px-5 py-3 backdrop-blur">
            <p className="text-xs uppercase tracking-widest text-ink/50">Locally owned</p>
            <p className="font-display text-lg">Detailing you can trust</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
